// ── Guided First Week Onboarding ─────────────────────────────────────────
// Tracks user progress through key first-week actions.
// Stored in Firestore under users/{uid}/onboarding

export const ONBOARDING_STEPS = [
  {
    id:       'photo',
    day:      0,
    label:    'Add your first photo',
    labelFR:  'Ajouter ta première photo',
    reward:   '+2× visibility for 24h',
    rewardFR: '+2× visibilité pendant 24h',
    icon:     '◎',
    check:    (user) => (user.photos || []).length > 0,
  },
  {
    id:       'quiz',
    day:      0,
    label:    'Complete the compatibility quiz',
    labelFR:  'Compléter le quiz de compatibilité',
    reward:   'Unlocks compatibility scores',
    rewardFR: 'Débloque les scores de compatibilité',
    icon:     '✦',
    check:    (user) => Object.keys(user.quiz_answers || {}).length >= 8,
  },
  {
    id:       'bio',
    day:      1,
    label:    'Write your bio',
    labelFR:  'Écrire ta bio',
    reward:   '+30% more likes',
    rewardFR: '+30% de likes en plus',
    icon:     '✎',
    check:    (user) => (user.bio || '').length > 20,
  },
  {
    id:       'interests',
    day:      1,
    label:    'Add 5+ interests',
    labelFR:  'Ajouter 5+ intérêts',
    reward:   'Better Circle matches',
    rewardFR: 'Meilleurs matchs de Circle',
    icon:     '✦',
    check:    (user) => (user.interests || []).length >= 5,
  },
  {
    id:       'verify',
    day:      2,
    label:    'Verify your email or phone',
    labelFR:  'Vérifier ton email ou téléphone',
    reward:   '✓ Verified badge · 3× visibility',
    rewardFR: 'Badge ✓ Vérifié · 3× visibilité',
    icon:     '·',
    check:    (user) => user.emailVerified || user.phoneVerified,
  },
  {
    id:       'invite',
    day:      3,
    label:    'Invite a friend',
    labelFR:  'Inviter un ami',
    reward:   'Both get 7 days Honey free',
    rewardFR: 'Vous recevez 7 jours Honey gratuits',
    icon:     '✦',
    check:    (user) => (user.inviteCount || 0) > 0,
  },
  {
    id:       'like',
    day:      3,
    label:    'Like your first profile',
    labelFR:  'Liker ton premier profil',
    reward:   'Start discovering',
    rewardFR: 'Commence à découvrir',
    icon:     '♥',
    check:    (user, stats) => (stats?.likes || 0) > 0,
  },
];

// ── Compute completed steps ───────────────────────────────────────────────
export function getOnboardingProgress(user, stats = {}, features = {}) {
  const visibleSteps = ONBOARDING_STEPS.filter(s => {
    if (s.id === 'verify' && !features?.sms_verification) return false;
    return true;
  });
  const completed = visibleSteps.filter(s => s.check(user, stats));
  const pct = Math.round((completed.length / visibleSteps.length) * 100);
  return {
    steps:     visibleSteps.map(s => ({ ...s, done: s.check(user, stats) })),
    completed: completed.length,
    total:     visibleSteps.length,
    pct,
    allDone:   completed.length === visibleSteps.length,
    nextStep:  visibleSteps.find(s => !s.check(user, stats)) || null,
  };
}

// ── Re-engagement nudge schedule ──────────────────────────────────────────
export const NUDGES = [
  { dayAfterSignup: 1,  type: 'first_match',  title: 'Someone liked you!',            titleFR: 'Quelqu\'un t\'a liké !' },
  { dayAfterSignup: 3,  type: 'complete_bio',  title: 'Your profile is 60% complete',  titleFR: 'Ton profil est complet à 60%' },
  { dayAfterSignup: 7,  type: 'first_circle',  title: 'A Circle is forming near you',  titleFR: 'Un Circle se forme près de toi' },
  { dayAfterSignup: 14, type: 'weekly_digest', title: 'Your weekly BeeLove digest',    titleFR: 'Ton récap BeeLove de la semaine' },
];
